import { z } from 'zod';
import { companySchema } from './company-schema';
import { districtSchema } from './district-schema';
import { imageSchema } from './image-schema';
import { locationSchema } from './location-schema';
import { metaSchema } from './meta-schema';
import { officeSchema } from './office-schema';
import { pageConfigurationSchema } from './page-configuration-schema';
import { personSchema } from './person-schema';

export type TCity = z.infer<typeof citySchema>;

export const citySchema = z.object({
  id: z.number(),
  attributes: z.object({
    name: z.string(),
    companies: z.object({
      data: z.array(companySchema),
    }),
    offices: z.object({
      data: z.array(officeSchema),
    }),
    districts: z.object({
      data: z.array(districtSchema),
    }),
    people: z.object({
      data: z.array(personSchema),
    }),
    configuration: pageConfigurationSchema,
    background: imageSchema,
    meta: metaSchema,
    location: locationSchema,
  }),
});
